export default __webpack_public_path__ + "media/images/User_Group_Business-2630bb792289057458191ef89e85ca1f.png";